@import '../../../global/reset';

*, ::before, ::after {
	box-sizing: border-box;
	color: inherit;
	font-family: inherit;
	overflow-wrap: break-word;
}

@mixin visually-hidden {
	position: absolute     !important;
	height: 1px            !important;
	width:  1px            !important;
	white-space: nowrap    !important;
	overflow: hidden       !important;
	clip-path: inset(100%) !important;
	border: 0              !important;
	padding: 0             !important;
	margin: 0              !important;
	outline: none          !important;
}
.visually-hidden:not(:focus-visible) {
	@include visually-hidden;
}

[hidden] {
	display: none !important;
}

:disabled, .disabled {
	pointer-events: none;
	cursor: not-allowed;
	opacity: 0.8;
	filter: grayscale(0.4);
}

button {
	appearance: none;
	background: none;
	padding: 0;
	border: none;
	margin: 0;
	line-height: 1;
	text-decoration: none;
	cursor: pointer;
}
:host {
	display: contents;
}

#container {
	--shadow: 0 2px 4px hsl(0 0% 0% / 20%);
	position: relative;
	background-color: white;
	box-shadow: var(--shadow);

	@include media-breakpoint-down(lg) {
		display: flex;
		gap: 1em;

		&,
		app-details#collapsable-menu::part(content) {
			padding-inline: var(--inline-page-margin);
		}

		slot[name='logo']::slotted(*) {
			margin-inline-end: auto;
		}

		app-details#collapsable-menu {
			&::part(summary),
			&::part(toggle) {
				block-size: 100%;
			}

			&::part(toggle) {
				display: grid;
				place-content: center;
				inline-size: 45px;
				block-size: 100%;
			}

			&::part(content) {
				position: absolute;
				inset-block-start: 100%;
				inset-inline: 0;
				background-color: white;
				box-shadow: inset var(--shadow);
			}

			& app-icon {
				background-color: $secondary;
				color: #ffffff;
				border-radius: 50%;
				display: grid;
				place-content: center;
				inline-size: 36px;
				block-size: 36px;
				aspect-ratio: 1;
				margin-bottom: 6px;

				svg {
					inline-size: 16px;
				}
			}
			.icon-text {
				font-size: 14px;
				line-height: 14px;
				color: $primary;
			}
		}
	}
	@include media-breakpoint-up(lg) {
		#top-ribbon,
		#main-bar {
			padding-inline: 50px;
		}

		#top-ribbon {
			display: flex;
			gap: 1em;
			padding-block: 4px;
			align-items: center;
			justify-content: end;
			background-color: #F6F4EF;
			color: $primary;
		}

		#main-bar {
			display: flex;
			gap: 1em;
			position: relative;
			z-index: 99;

			slot[name='logo']::slotted(*) {
				margin-inline-end: auto;
			}
		}
	}
}
